module.exports = __webpack_public_path__ + "static/media/ic_ubicacion_actual.c583f16d.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_ubicacion_actual.webp
// module id = 192
// module chunks = 1